module.exports = __webpack_public_path__ + "static/media/restart.7a8ca4f4.png";